<template>
    <div class="col-md-5">
        <slot name="title"></slot>
        <select name="input" @change="onChange" v-model="selected" ref="combo">
            <option v-for="(label, geoCode) in municipalities" :key="geoCode" :value="geoCode">
                <span v-text="`${label} (${geoCode})`"></span>
            </option>
        </select>
    </div>
</template>

<script>

export default {
    name: 'TransferInput',

    props: {
        callback: {
            type: Function
        },
        list: {
            type: String
        }
    },

    data () {
        return {
            selected: null,
            municipalities: null
        }
    },

    created () {
        this.municipalities = JSON.parse(this.list)
        const indexes = Object.keys(this.municipalities)
        if (indexes.length > 0) {
            this.selected = indexes[0]
        }
    },

    mounted () {
        this.callback(this.selected)
    },

    methods: {
        onChange () {
            this.callback(this.selected)
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/transfer-inputs.vue